<div
  class="or-mx-16-px or-mt-16-px border-shade border-radius-4 or-bg-white or-p-16-px or-d-flex or-flex-col or-align-items-center">
  <div class="empty-state__icon or-d-flex or-align-items-center or-justify-content-center or-mb-12-px">
    <or-icon name="calendar" size="l" circle />
  </div>

  <div class="or-head-sm or-text-align-center or-mb-16-px">Sprawdź, kto gra w okolicy, albo stwórz własną gierkę.</div>

  <button
    (click)="goToSearchGames()"
    class="button-primary-style or-w-100-pc or-h-48-px or-head-xs or-color-white or-d-flex or-align-items-center or-justify-content-center">
    <or-icon name="search-2" size="s" class="or-color-white or-mr-8-px" />
    Sprawdź dostępne gierki
  </button>

  <button
    (click)="goToGameCreator()"
    class="button-secondary-style or-w-100-pc or-h-48-px or-head-xs or-mt-12-px or-d-flex or-align-items-center or-justify-content-center">
    <or-icon name="plus" size="s" class="or-mr-8-px" />
    Stwórz nową gierkę
  </button>
</div>
